import { render } from "./MatchBracket.vue?vue&type=template&id=14c3d10b&scoped=true"
import script from "./MatchBracket.vue?vue&type=script&lang=js"
export * from "./MatchBracket.vue?vue&type=script&lang=js"

import "./MatchBracket.vue?vue&type=style&index=0&id=14c3d10b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c3d10b"]])

export default __exports__